import { useMemo, useState } from "react";

import {
  Button,
  ChevronDownSVG,
  ChevronUpSVG,
  Icon,
  type SvgComponentType,
} from "@newsela/angelou";

import { getReportsButtonCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ReportsMenu/ReportsMenu.styles";
import { ReportsMenuPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ReportsMenu/ReportsMenuPopout/ReportsMenuPopout";
import { useGetReportsMenuSectionProps } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useGetReportsMenuSectionProps/useGetReportsMenuSectionProps";
import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import { NavButtonWithPopoutText } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavButtonWithPopoutText";
import { User } from "@/types/models";

interface Props {
  user: User;
}

const MENU_ID = "nav-classes-menu";

const ReportsMenu = ({ user }: Props) => {
  const { reportsMenuSectionTitle } = useGetReportsMenuSectionProps();

  const [isOpen, setIsOpen] = useState(false);

  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen,
        id: MENU_ID,
      }),
    [isOpen],
  );

  const onClickButton = () => setIsOpen((isOpen) => !isOpen);

  return (
    <NavButtonWithPopout
      id={MENU_ID}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      position={{ top: "4rem", left: 0 }}
      rootCustomCss={{ display: "flex" }}
      ButtonComponent={
        <Button
          onClick={onClickButton}
          ariaProps={buttonAriaProps}
          flavor={Button.flavors.incognito}
          dataProps={{ "data-qa-selector": "global-nav-classes-menu" }}
          __cssFor={getReportsButtonCss(isOpen)}
          __classNameFor={{ root: MENU_ID }}
        >
          <NavButtonWithPopoutText>
            {reportsMenuSectionTitle}
          </NavButtonWithPopoutText>

          {isOpen ? (
            <Icon SvgComponent={ChevronUpSVG as SvgComponentType} />
          ) : (
            <Icon SvgComponent={ChevronDownSVG as SvgComponentType} />
          )}
        </Button>
      }
      PopoutComponent={<ReportsMenuPopout user={user} />}
    />
  );
};

ReportsMenu.displayName = "ClassesMenu";
export { ReportsMenu };
